import { TaskDto } from './task.dto';

export class GetTasksResponseDto {
    tasks: TaskDto[];

    constructor(tasks: TaskDto[]) {
        this.tasks = tasks;
    }
}
